import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useApiData } from "../hooks/useApiData";
import "./PageContent.css";
import BackToTopButton from "../components/BackToTopButton";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001/api";

  const SERVER_URL = API_URL.replace(/\/api\/?$/, "");
  

export default function PageContent() {
  const { mainSlug, subSlug, subSubSlug } = useParams();

  const slugPath = [mainSlug, subSlug, subSubSlug]
    .filter(Boolean)
    .join("/");

  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  /* =====================================================
     LEADERSHIP DATA
     ===================================================== */

  const { data: leaders } = useApiData("leadership");

  /* =====================================================
     FIND PRINCIPAL
     ===================================================== */

  const principal = leaders?.find((leader) => {
    const role = String(leader.role || "").toLowerCase();

    return (
      role.includes("principal") ||
      role.includes("dean")
    );
  });

  /* =====================================================
     FIND MEDICAL SUPERINTENDENT
     ===================================================== */

  const medicalSuperintendent = leaders?.find((leader) => {
    const role = String(leader.role || "").toLowerCase();

    return role.includes("medical superintendent");
  });

  /* =====================================================
     FETCH PAGE CONTENT
     ===================================================== */

  // useEffect(() => {
  //   setLoading(true);

  //   fetch(`${API_URL}/pagecontent/resolve/${slugPath}`)
  //     .then((res) => {
  //       if (!res.ok) {
  //         throw new Error("Page not found");
  //       }

  //       return res.json();
  //     })
  //     .then((data) => {
  //       setPage(data.data);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       setPage(null);
  //       setLoading(false);
  //     });
  // }, [slugPath]);


  useEffect(() => {
  setLoading(true);

  const isLeadershipMessage =
    mainSlug === "leadership-message" && subSlug && !subSubSlug;

  const endpoint = isLeadershipMessage
    ? `${API_URL}/leadership/slug/${subSlug}`
    : `${API_URL}/pagecontent/resolve/${slugPath}`;

  fetch(endpoint)
    .then((res) => {
      if (!res.ok) throw new Error("Page not found");
      return res.json();
    })
    .then((data) => {
      if (isLeadershipMessage) {
        // data shape: { id, slug, role, name, img, message, fullHtml }
        // setPage({
        //   page_title: `${data.name} — ${data.role}`,
        //   page_contents: data.fullHtml || `<p>${data.message}</p>`,
        //   attachment: null,
        // });

        setPage({
          page_title: data.role || data.name || "",
          page_contents: data.fullHtml || `<p>${data.message}</p>`,
          attachment: null,
        });
      } else {
        setPage(data.data);
      }
      setLoading(false);
    })
    .catch((err) => {
      console.error(err);
      setPage(null);
      setLoading(false);
    });
}, [slugPath, mainSlug, subSlug, subSubSlug]);

  /* =====================================================
     LOADING
     ===================================================== */

  if (loading) {
    return (
      <div className="content-page-wrapper">
        <div className="content-container">

          <div className="content-loading">

            <div className="content-spinner"></div>

            <p>Loading content...</p>

          </div>

        </div>
      </div>
    );
  }

  /* =====================================================
     PAGE NOT FOUND
     ===================================================== */

  if (!page) {
    return (
      <div className="content-page-wrapper">

        <div className="content-container">

          <div className="content-not-found">

            <div className="not-found-icon">
              <i className="fa fa-file-text-o"></i>
            </div>

            <h2>Page Not Found</h2>

            <p>
              The requested page could not be found or may have
              been removed.
            </p>

            <Link
              to="/"
              className="back-home-btn"
            >
              <i className="fa fa-home"></i>
              Back to Home
            </Link>

          </div>

        </div>

      </div>
    );
  }

  /* =====================================================
     BREADCRUMB
     ===================================================== */

  const breadcrumbItems = [
    mainSlug,
    subSlug,
    subSubSlug,
  ].filter(Boolean);

  const formatSlug = (slug) => {
    if (!slug) return "";

    return slug
      .replace(/-/g, " ")
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };

  const slugify = (str) =>
  String(str || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

  /* =====================================================
     LEADERSHIP MESSAGE PREVIEW
     ===================================================== */

  const renderOfficialMessage = (
    leader,
    title,
    icon
  ) => {
    if (!leader) {
      return null;
    }

    return (
      <div className="official-message-block">

        {/* GREEN TITLE */}

        <div className="official-message-title">
          {title}
        </div>


        {/* MESSAGE AREA */}

        <div className="official-message-body">

          <div className="official-message-top">

            {/* PHOTO */}

            <div className="official-photo-wrapper">

              <img
                src={leader.img}
                alt={leader.name}
                className="official-photo"
                onError={(e) => {
                  e.target.src =
                    `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      leader.name || "Official"
                    )}&background=0b5d7a&color=fff&size=150`;
                }}
              />

            </div>


            {/* MESSAGE */}

            <div className="official-message-text">

              <p>
                {leader.message}
              </p>

            </div>

          </div>


          {/* NAME */}

          <div className="official-name">
            {leader.name}
          </div>


          {/* ROLE */}

          <div className="official-role">
            {leader.role}
          </div>


          {/* MORE */}

          <div className="official-more-wrapper">

            {/* <Link
              to={`/leadership-message/${leader.id}`}
              className="official-more"
            >
              More...
            </Link> */}

            <Link
  to={`/leadership-message/${slugify(leader.role)}`}
  className="official-more"
>
  More...
</Link>

          </div>

        </div>

      </div>
    );
  };

  /* =====================================================
     PAGE
     ===================================================== */

  return (
    <main className="content-page-wrapper">

      {/* =================================================
          BREADCRUMB
          ================================================= */}

      <div className="content-breadcrumb-wrapper">

        <div className="content-container">

          <div className="content-breadcrumb">

            <Link to="/">
              <i className="fa fa-home"></i>
              Home
            </Link>

            {breadcrumbItems.map((item, index) => (
              <React.Fragment
                key={`${item}-${index}`}
              >

                <span className="breadcrumb-arrow">
                  <i className="fa fa-angle-right"></i>
                </span>

                <span
                  className={
                    index === breadcrumbItems.length - 1
                      ? "breadcrumb-current"
                      : ""
                  }
                >
                  {formatSlug(item)}
                </span>

              </React.Fragment>
            ))}

          </div>

        </div>

      </div>


      {/* =================================================
          MAIN LAYOUT
          ================================================= */}

      <div className="content-container">

        <div className="content-layout">


          {/* =================================================
              LEFT SIDEBAR
              ================================================= */}

          <aside className="content-sidebar">

            {/* =================================================
                OFFICIAL INFORMATION
                ================================================= */}

            <div className="official-info-card">

              {/* HEADER */}

              <div className="official-info-header">

                <div className="official-info-icon">

                  <i className="fa fa-envelope-o"></i>

                </div>

                <span>
                  MESSAGE FROM
                </span>

              </div>


              {/* LEADERS */}

              <div className="official-info-body">

                {/* PRINCIPAL */}

                {renderOfficialMessage(
                  principal,
                  "DEAN AND PRINCIPAL",
                  "fa-user"
                )}


                {/* MEDICAL SUPERINTENDENT */}

                {renderOfficialMessage(
                  medicalSuperintendent,
                  "MEDICAL SUPERINTENDENT",
                  "fa-user-md"
                )}

              </div>

            </div>

          </aside>


          {/* =================================================
              RIGHT SIDE - PAGE CONTENT
              ================================================= */}

          <section className="content-main-card">


            {/* =================================================
                PAGE HEADER
                ================================================= */}

            <div className="content-header">

          


              <div className="notice-page-title" style={{width: "100%"}}>

                <h1>
                  {page.page_title}
                </h1>

              

              </div>

            </div>


            {/* =================================================
                PAGE HTML CONTENT
                ================================================= */}

            <article
              className="page-html-content"
              dangerouslySetInnerHTML={{
                __html: page.page_contents,
              }}
            />


            {/* =================================================
                ATTACHMENT
                ================================================= */}

            {page.attachment && (

              <div className="content-attachment-section">


                <div className="attachment-heading">

                  <i className="fa fa-paperclip"></i>

                  Related Document

                </div>


                <div className="attachment-card">


                  <div className="attachment-left">

                    <div className="attachment-icon">

                      <i
                        className={
                          /\.pdf$/i.test(page.attachment)
                            ? "fa fa-file-pdf-o"
                            : /\.(doc|docx)$/i.test(
                                page.attachment
                              )
                            ? "fa fa-file-word-o"
                            : /\.(xls|xlsx)$/i.test(
                                page.attachment
                              )
                            ? "fa fa-file-excel-o"
                            : /\.(jpg|jpeg|png|gif)$/i.test(
                                page.attachment
                              )
                            ? "fa fa-file-image-o"
                            : "fa fa-file-o"
                        }
                      ></i>

                    </div>


                    <div className="attachment-info">

                      <strong>
                        Official Document
                      </strong>

                      <span>
                        Click the button to view the attached
                        document.
                      </span>

                    </div>

                  </div>


                  {/* <a
                    href={`${API_URL}/${page.attachment}`}
                    target="_blank"
                    rel="noreferrer"
                    className="attachment-view-btn"
                  >

                    <i className="fa fa-eye"></i>

                    View Document

                  </a> */}

                  <a
                    href={`${SERVER_URL}/images/menudocuments/${page.attachment.split("/").pop()}`}
                    target="_blank"
                    rel="noreferrer"
                    className="attachment-view-btn"
                  >
                    <i className="fa fa-eye"></i>
                    View Document
                  </a>

                </div>

              </div>

            )}

          </section>

        </div>

      </div>
      {/* Back to top button */}
<BackToTopButton />

    </main>
  );
}